/**
 * A random RFC 4122 version-4 UUID, e.g. `1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed`.
 *
 * `crypto.randomUUID` only exists on SECURE pages (HTTPS, or localhost). A phone
 * or iPad testing a dev server over the LAN (`http://192.168.…:3000`) is not
 * one, so there it is undefined and every path that minted an id threw
 * ("crypto.randomUUID is not a function"). `crypto.getRandomValues` exists on
 * any page, so the same UUID is built from it when `randomUUID` is missing:
 * same format, same cryptographically strong source.
 *
 * Use this instead of calling `crypto.randomUUID()` directly.
 */
export const newUuid = () => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join(
    ''
  );
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-');
};
